import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import BaseController from '../../../BaseController';
import { FragmentNames, HealthHistorySocialHistoryListAliases } from '../../../../codegen/index';
import { ApplicationRoute } from '../../../../constants/routes';
import { HealthHistoryListContext } from '../../service/health-history-list-service';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';

@Controller ({ component: HealthHistorySocialHistoryListAliases.LAYOUT_HEALTH_HISTORY_SOCIAL_HISTORY_LIST, fragment: FragmentNames.HEALTH_HISTORY_SOCIAL_HISTORY_LIST })
export default class HealthHistorySocialHistortListController extends BaseController {

  @Inject(HealthHistorySocialHistoryListAliases.PANEL_SOCIAL_HISTORY_LIST)
  private panelHealthHistorySocialHistoryAPI!: PanelAPI;

  @OnMount(HealthHistorySocialHistoryListAliases.LAYOUT_HEALTH_HISTORY_SOCIAL_HISTORY_LIST)
  handleMountLayoutAllergiesList(): void {
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    this.panelHealthHistorySocialHistoryAPI.setVisible(allowInfo);
  }

  @OnClick({ target: HealthHistorySocialHistoryListAliases.BUTTON_ADD_HEALTH_HISTORY_SOCIAL_HISTORY })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.HEALTH_HISTORY_SOCIAL_HISTORY_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: HealthHistorySocialHistoryListAliases.DECK_SOCIAL_HISTORY })
  handleOnClickCard(event: ClickEvent): void {
    const { idHealthHistory, releaseDate } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    const accessViewer = releaseDate || !allowInfo;
    const route = accessViewer ? ApplicationRoute.HEALTH_HISTORY_SOCIAL_HISTORY_VIEWER : ApplicationRoute.HEALTH_HISTORY_SOCIAL_HISTORY_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idHealthHistory,
      patientId,
    });
  }
}
